export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_RIDER = 'GET_REBATE_PROGRAM_RIDER';
export const GET_RIDER_REPORT = 'GET_RIDER_REPORT';
export const SET_SELECTED_INPUT_RIDER = 'SET_SELECTED_INPUT_RIDER';
export const REFRESH_RIDER_REPORT = 'REFRESH_RIDER_REPORT';
export const IS_LOADING = 'IS_LOADING';
export const REFRESH_RIDER_REPORT_DISPLAY = 'REFRESH_RIDER_REPORT_DISPLAY';
export const SET_PAGINATION_INDEX_RIDER = 'SET_PAGINATION_INDEX_RIDER';
